import ApplicationController from "./application_controller";
import flatpickr from "flatpickr";
import { Czech } from "flatpickr/dist/l10n/cs.js";
import { Eng } from "flatpickr/dist/l10n/default.js";

export default class extends ApplicationController {
  static targets = ["inputDate"];

  initialize() {
    let locale = document.querySelector("#locale");
    if (locale == "en") {
      locale = Eng;
    } else {
      locale = Czech;
    }

    this.inputDateTargets.forEach((element) => {
      const dateFormat = element.dataset.dateFormat;
      const altFormat = element.dataset.altFormat;
      const altInput = element.dataset.altInput === "true";
      const enableTime = element.dataset.enableTime === "true" ||
                         (dateFormat && (dateFormat.includes("H") || dateFormat.includes("h"))) ||
                         (altFormat && (altFormat.includes("H") || altFormat.includes("h")));

      flatpickr(element, {
        locale: locale,
        dateFormat: dateFormat || (enableTime ? "d.m.Y H:i" : "d.m.Y"),
        altFormat: altFormat || (enableTime ? "d.m.Y H:i" : "d.m.Y"),
        altInput: altInput,
        enableTime: !!enableTime,
        time_24hr: true,
      });
    });

    // flatpickr(this.toTarget, {
    //   locale:  locale,
    //   dateFormat: 'd.m.Y',
    // });
  }
}
